module.exports = __webpack_public_path__ + "img/culture-reports.ef84df63.svg";